<button
  (click)="showToaster(state)"
  [ngClass]="{
    'toast-success': state.category === 'success',
    'toast-error': state.category === 'error'
  }"
>
  Show Toaster
</button>
